<input nz-input placeholder="User Email" [(ngModel)]="email" type="text" />

<div style="text-align: center; padding-top: 20px;">
    <button nz-button nzType="primary" (click)="sendOnline()" style="margin-right: 5px;" [disabled]="!email">
        Test Online
    </button>

    <button nz-button nzType="primary" (click)="sendOffline()" [disabled]="!email">
        Test Offline
    </button>
</div>